function createEmitterHelpers(getClient) {
  return {
    onEvent(...args) {
      getClient().on(...args);
    },
  };
}

export default createEmitterHelpers;
